import s from "./NewsWidgetMobile.module.scss"

export const NewsWidgetMobileSkeleton = () => {
  return (
    <div className={s.skeleton}>
      <div className={s.skeleton__image} />
      <div className={s.skeleton__wrapper}>
        <div className={s.skeleton__title} />
        <div className={s.skeleton__description} />
      </div>
      <div className={s.skeleton__arrow} />
    </div>
  )
}
